import React, { useEffect } from "react";
import {
  Car,
  Settings,
  Cpu,
  Wrench,
  Gauge,
  Factory,
} from "lucide-react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import car from "../../assets/car.gif";
import collab from "../../assets/collab.png";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import "./Automotive.css";

export default function Automotive() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const benefits = [
    {
      icon: <Car className="benefit-icon" />,
      title: "Automotive Excellence",
      desc: "Delivering end-to-end digital MES solutions for precision automotive manufacturing.",
    },
    {
      icon: <Settings className="benefit-icon" />,
      title: "Process Optimization",
      desc: "Streamlined production lines and real-time visibility for enhanced efficiency.",
    },
    {
      icon: <Cpu className="benefit-icon" />,
      title: "Smart Automation",
      desc: "Integrating IoT-driven controls and predictive insights to power intelligent manufacturing.",
    },
    {
      icon: <Gauge className="benefit-icon" />,
      title: "Performance Tracking",
      desc: "Detailed analytics on production performance, downtime, and quality control metrics.",
    },
  ];

  const capabilities = [
    {
      icon: <Wrench className="benefit-icon" />,
      title: "Component Assembly",
      desc: "Precision tracking and real-time quality assurance for component production lines.",
    },
    {
      icon: <Factory className="benefit-icon" />,
      title: "Production Monitoring",
      desc: "Monitor machines, tools, and operators in a unified digital platform.",
    },
    {
      icon: <Cpu className="benefit-icon" />,
      title: "AI-Based Quality Control",
      desc: "Early detection of faults through AI vision and intelligent decision systems.",
    },
  ];

  return (
    <>
      <Header />

      <div className="automotive-page">
        {/* Hero Section */}
        <section
          className="automotive-hero"
          style={{
    backgroundImage: `url(${car})`,
  }}
        >
          <div className="automotive-hero-overlay"></div>
          <h1 className="automotive-hero-title">Automotive Industry Solutions</h1>
          <p className="automotive-hero-subtitle">
            Driving innovation, precision, and performance in automotive manufacturing.
          </p>
        </section>

        {/* Intro Section */}
        <section className="automotive-intro">
          <h2>Empowering Automotive Manufacturing</h2>
          <p>
            Larch Automotive MES transforms conventional automotive production into an
            intelligent, connected, and data-driven ecosystem. From part fabrication to
            final assembly, our solutions ensure traceability, efficiency, and innovation
            at every stage.
          </p>
        </section>

        {/* Benefits Section */}
        <section className="automotive-benefits">
          <h2>Why Choose Larch for Automotive?</h2>
          <div className="automotive-benefit-cards">
            {benefits.map((b, i) => (
              <div key={i} className="automotive-benefit-card">
                {b.icon}
                <h3>{b.title}</h3>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Capabilities Section */}
        <section className="automotive-capabilities">
          <h2>Core Capabilities</h2>
          <div className="automotive-capability-cards">
            {capabilities.map((c, i) => (
              <div key={i} className="automotive-capability-card">
                {c.icon}
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </section>

    {/* Industries We Serve Section */}
<section className="automotive-industries">
  <h2>Industries We Serve</h2>
  <p>
    From electric vehicles to precision components, our Automotive MES empowers
    every segment of the manufacturing ecosystem with intelligence and agility.
  </p>

  <div className="industry-grid">
    <div className="industry-item">
      <div className="overlay"></div>
      <img src={collab} alt="OEMs" />
      <h3>OEM Manufacturers</h3>
    </div>
    <div className="industry-item">
      <div className="overlay"></div>
      <img src={collab} alt="EV" />
      <h3>Electric Vehicles</h3>
    </div>
    <div className="industry-item">
      <div className="overlay"></div>
      <img src={collab} alt="Components" />
      <h3>Component Suppliers</h3>
    </div>
    <div className="industry-item">
      <div className="overlay"></div>
      <img src={collab} alt="Tier 1 Suppliers" />
      <h3>Tier 1 Suppliers</h3>
    </div>
  </div>
</section>
        {/* Digital Transformation Section */}
<section className="automotive-digital">
  <div className="automotive-digital-content">
    <div className="digital-text">
      <h2>Digital Transformation in Automotive</h2>
      <p>
        The automotive industry is accelerating toward smart factories powered by
        data, AI, and automation. Larch Automotive MES bridges the gap between
        design, production, and quality — empowering manufacturers to embrace
        Industry 4.0 with confidence.
      </p>
      <p>
        With real-time visibility, predictive maintenance, and process
        synchronization, Larch helps manufacturers reduce downtime, enhance
        traceability, and achieve peak operational performance.
      </p>
      <a href="#contact" className="digital-btn">Learn More</a>
    </div>
    <div className="digital-image">
      <img src={collab} alt="Automotive Digital Transformation" />
    </div>
  </div>
</section>


{/* Client Impact Section */}
{/* <section className="automotive-impact">
  <h2>Client Impact</h2>
  <p>
    Trusted by global automotive leaders to drive productivity, precision, and
    profitability.
  </p>

  <div className="impact-stats">
    <div className="stat">
      <h3>30%</h3>
      <p>Reduction in Downtime</p>
    </div>
    <div className="stat">
      <h3>99.9%</h3>
      <p>Quality Compliance</p>
    </div>
    <div className="stat">
      <h3>2x</h3>
      <p>Faster Production Cycles</p>
    </div>
    <div className="stat">
      <h3>24/7</h3>
      <p>Operational Visibility</p>
    </div>
  </div>
</section> */}


      </div>

      <ERPChatbot />
      <Footer />
    </>
  );
}
